<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import SportLiveTvBadge from '@/sport-live-tv/components/sport-live-tv-badge.vue';
import SportLiveTvEventLogo from '@/sport-live-tv/components/sport-live-tv-event-logo.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';
import { getSportLiveTvEventStatus } from '@/sport-live-tv/helpers';

const props = defineProps({
  event: { type: Object, required: true },
});

const store = useStore();
const { t: tGlobal } = useI18n();
const { t } = useSportLiveTvTranslation();

const status = computed(() => getSportLiveTvEventStatus(props.event));
const isForSubscribersOnly = computed(() => !props.event.allowed_by_trial && store.getters.isTrial);
</script>

<template>
  <div class="sport-live-tv-event-card-cover">
    <SportLiveTvBadge class="sport-live-tv-event-card-cover__badge" :status="status" :label="t(status)" />
    <SportLiveTvEventLogo :event="event" />
    <div v-if="isForSubscribersOnly" class="sport-live-tv-event-card-cover__subs-only">{{ tGlobal('forSubsOnly') }}</div>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-event-card-cover {
  position: relative;
  padding: 12px 12px 0;

  &__badge {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 1;
  }

  &__subs-only {
    position: absolute;
    inset: 12px 12px 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    border-radius: 6px;
    background-color: rgba($black, 0.75);
    color: $white;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
  }
}
</style>
